// extracted by mini-css-extract-plugin
export default {"background":"account-popup_background__71GzE","accountPopup":"account-popup_accountPopup__t31m8","link":"account-popup_link__3HB4T","close":"account-popup_close__REzTf"};